import React from 'react'
import { Text } from 'theme-ui'

import { BenefitStyled, BenefitIconStyled, BenefitTextStyled } from './styles'
import StaticImage from './../../atoms/ImageStatic'
import { BenefitProps } from './types'

const Benefit: React.FC<BenefitProps> = ({ icon, title }) => {
  return (
    <BenefitStyled>
      {icon && (
        <BenefitIconStyled>
          <StaticImage image={icon} />
        </BenefitIconStyled>
      )}
      <BenefitTextStyled>
        <Text variant="bodyMontserrat8">{title}</Text>
      </BenefitTextStyled>
    </BenefitStyled>
  )
}

export default Benefit
